module.exports = __webpack_public_path__ + "static/media/19ESCAP34.e8642ddb.jpg";